<template>
  <div class="w-full">
    <div class="flex flex-wrap w-full justify-between items-center gap-x-1 gap-y-3">
      <!-- order form modal -->
      <client-only>
        <!-- for all types except offer -->
        <OrderDetailsVue 
          :isOrderFormModalOpen="isOrderFormModalOpen" 
          :isNotLoggedIn="isNotLoggedIn" 
          :isGuest="isGuest"
          :isLoading="isLoading" 
          :changeOrderModalState="changeOrderModalState" 
          :handleCreateOrder="handleCreateOrder"
          :productData="this.productData"
          :branchData="this.branchData"
          :productUpdatedPrice="priceAfterSelectingBranch"
          :productBasicPrice="productData && productData.basic_price"
          :isNewOrder="isNewOrder"
          :maxQuantity="maxQuantity"
          :fromCartBoolean="fromCart"
          @confirmActionForAdd="confirmAction"
          
          />
          <!-- for offer type -->

          <!-- quantity segments -->
          <OrderDetailsOffer
          v-if="isQuantityOfferModelOpen && productTypeId === 'offer'"
          :isOrderFormModalOpen="isQuantityOfferModelOpen" 
          :isNotLoggedIn="isNotLoggedIn" 
          :isGuest="isGuest"
          :isLoading="isLoading" 
          :changeOrderModalState="changeQuantityOfferModalState" 
          :handleCreateOrder="handleCreateOrder"
          :productData="this.productData"
          :branchData="this.branchData"
          :productUpdatedPrice="priceAfterSelectingBranch"
          :productBasicPrice="productData && productData.basic_price"
          :isNewOrder="isNewOrder"
          :maxQuantity="maxQuantity"
          @confirmActionForOffer="confirmActionForOffer"
          /> 

          <!-- choose the offer -->
          <OfferOrderDetails
          v-if="isOfferOrderDetailsModalOpen && productTypeId === 'offer'"
          :isModalOpen="isOfferOrderDetailsModalOpen"
          :changeModalState="changeOfferOrderDetailsModalState"
          :offerDetailsArray="offerDetailsArray"
          :productData="productData"
          @confirmActionForAddOffer="confirmActionForAddOffer"
          />

          <WarningSecurityContactModal
            :modalTitle="$t('general.contacts_info')"
            :isOpen="WarningSecurityContactModalState"
            :warningList="productData.warnings"
            :phoneNumber="storeData.phone"
            :whatsAppNumber="whatsappNumber"
            @close="WarningSecurityContactModalState = false"
          />
          <StoreWarningModal
            :isOpen="warningModalState"
            :warning="currentWarning"
            :storeName="storeData?.name || ''"
            @close="closeWarningModal"
          />
      </client-only>
       <div v-if="productData?.offer_end_timestamp" class="w-full mb-3">
        <div class="flex flex-col sm:flex-row items-center p-2 justify-center gap-2 sm:gap-4 h-fit rounded-md text-white relative shadow-[0_0_40px_rgba(132,27,12,0.5)] overflow-hidden" style="background: linear-gradient(90deg, #841B0C 0%, #241921 24%, #4F3749 74%, #8A607F 100%)">
          <img 
            src="@/assets/icons/Offer.svg" 
            alt="timer" 
            class="w-[50px] h-[50px] sm:w-[50px] sm:h-[50px] lg:w-[40px] lg:h-[40px] absolute"
            :style="{
              [$i18n.locale === 'ar' ? 'right' : 'left']: '0.75rem',
              top: '30%',
              transform: 'translateY(-50%)'
            }"
          />
          <div class="flex items-center gap-1 sm:gap-2" :class="{'sm:ml-12 lg:ml-14': $i18n.locale !== 'ar', 'sm:mr-12 lg:mr-14': $i18n.locale === 'ar'}">
            <span class="text-sm font-medium whitespace-nowrap"> {{ $t('general.offer_ends_in') }} </span>
          </div>
          <div class="flex items-center gap-2 sm:gap-4 lg:gap-6 flex-wrap justify-center">
            <template v-for="(value, index) in displayCountdown.time.split(',')" :key="index">
              <div class="flex flex-col items-center gap-1">
                <span class="text-xs">{{ displayCountdown.strings.split(',')[index] }}</span>
                <span class="text-sm sm:text-base lg:text-lg font-bold">{{ value }}</span>
              </div>
              <span v-if="index < displayCountdown.time.split(',').length - 1" class="text-sm sm:text-base lg:text-lg font-bold">:</span>
            </template>
          </div>
        </div>
      </div>
      <!-- page start -->
      <div class="flex w-full items-center gap-3">
        <h1 class="text-black text-[1.188rem] md:text-[1.25rem] lg:text-[1.372rem] font-bold flex-1">
          {{ productData[finalizedNameKey] }}
        </h1>
        <!-- interactive buttons group -->
        <div class="flex items-center gap-3 md:gap-4 shrink-0">
          <!-- Favorite/unfavorite button -->
          <client-only>
            <FavoriteBtn :favoriteProductsIDs="favoriteProductsIDs" :withAnimations="true"
              :id="productData && productData.id" />
          </client-only>
          <!-- Share button -->
          <button @click="() => changeShareProductModalState(true)" type="button" aria-label="share product"
            aria-labelledby="share product"
            class="bg-transparent grid place-content-center w-[31px] h-[31px] lg:w-[35px] lg:h-[35px] 3xl:w-[36px] 3xl:h-[36px] shadow-[0px_3px_6px_#00000029] rounded-full select-none hover:bg-gray-100/75 border-0 cursor-pointer hover:translate-y-[-2px] linear duration-200 focus:outline-none"
            title="Share product">
            <img src="@/assets/icons/share_gray.svg" class="object-contain w-[1rem] h-[1rem]" width="16" height="16"
              alt />
            <span class="sr-only">Share product</span>
          </button>
        </div>
      </div>
      <div 
        v-if="productData"
        class="w-full mt-3 flex flex-wrap gap-4 text-sm text-gray-600"
      >
        <p class="flex items-center gap-2">
          <span class="font-medium text-gray-900">{{ $t('general.views') }}:</span>
          <span>{{ productViewsDisplay }}</span>
        </p>
        <p class="flex items-center gap-2">
          <span class="font-medium text-gray-900">{{ $t('general.listed_since') }}:</span>
          <span>{{ productListedSince }}</span>
        </p>
      </div>
    </div>
    <div v-if="whatsappNumber" class="mt-2 md:mt-3">
      <!-- whatsapp button -->
      <WhatsappButton v-if="productData.warnings && productData.warnings.length > 0" :preventClick="true" :customClick="handleWhatsAppClick" :whatsappNumber="whatsappNumber" :message="$t('general.product_whatsapp_message')" />
      <WhatsappButton v-else :preventClick="false" :whatsappNumber="whatsappNumber" :message="$t('general.product_whatsapp_message')" />
    </div>
    <!-- Rating -->
    <client-only>
      <div class="mt-4 md:mt-5">
        <div v-if="productData.ratings_avg && parseInt(productData.ratings_avg) > 0" class="flex gap-3 items-center">
          <span class="flex items-center gap-1">
            <strong class="text-[1.188rem] md:text-[1.24rem] 3xl:text-[1.313rem]">
              {{ productData.ratings_avg ? Number(productData.ratings_avg).toLocaleString() : Number(0).toLocaleString() }}
            </strong>
          </span>
          <StarRating v-if="+productData.ratings_avg > 0" :rating="+productData.ratings_avg"
                  sizesClass="mt-0.5 w-[1.013rem] h-[1.013rem] md:w-[1.094rem] md:h-[1.094rem] mb-0.5" />

          <div class="text-[0.875rem] md:text-[0.938rem] 3xl:text-base text-[#848484]">{{ $t('user.ratings_count') }}
            ({{ arabizeNumbers(Number(productData.ratings_count).toLocaleString()) }})</div>
        </div>
      </div>
    </client-only>
    <!-- store address -->
    <div v-if="productData.store && productData.store.address" class="inline-flex items-center gap-1 mt-1" style="overflow-wrap: anywhere;">
      <img src="@/assets/icons/location.svg" class="w-[0.85rem] md:w-[0.9rem] lg:w-[1rem] h-auto object-contain" alt
        :width="14" :height="14" />
      <span class="inline-block text-[0.813rem]">{{ productData.store.address }}</span>
    </div>
    <!-- Hint for this Product is not available -->
    <div v-if="!isAvailableProduct" class="mt-2 md:mt-3">
      <div
        class="flex flex-col items-center gap-2 rounded px-4 py-3"
        :class="'bg-red-600 text-white'"
      >
        <span class="text-sm font-medium">{{ $t('general.this_product_is_not_available') }}</span>
      </div>
    </div>
    <!-- Price (hide when product is not available) -->
    <div v-if="isAvailableProduct" ref="imageScrollObserverTarget">
      <section>
        <!-- If Wholesale type -->
        <div v-if="productTypeId === 'wholesale' && wholesaleDetailsArray && wholesaleDetailsArray.length > 0"
          class="grid grid-cols-1 xxs:grid-cols-2 sm:grid-cols-3 mt-1.5 gap-3 md:gap-3.5 lg:gap-4">
          <div v-for="wholesaleItem in wholesaleDetailsArray" :key="wholesaleItem.id"
            class="py-2 md:py-3 px-4 gap-1.5 md:gap-2 bg-primaryLight3 text-center rounded-[0.625rem] text-[0.75rem] sm:text-[0.825rem] md:text-[0.9rem] 3xl:text-[0.938rem]">
            <!-- if 'more than' type -->
            <div v-if="wholesaleItem.to_quantity == -1">
              {{ $t('general.more_than') }} {{ wholesaleItem.from_quantity }} {{ $t('user.one_piece') }}
            </div>
            <!-- else -->
            <div v-else>
              {{ wholesaleItem.from_quantity }}-{{ wholesaleItem.to_quantity }} {{ $t('user.one_piece') }}
            </div>
            <div class="mt-1">
              <!-- <strong class="text-primary" >{{arabizeNumbers(priceAfterSelectingBranch).toLocaleString()}}</strong> -->
              <strong class="text-primary">{{ branchData.discount ?
              arabizeNumbers(Math.ceil(
                productData.discount ?
                wholesaleItem.price * (1 - (branchData.discount / 100)).toFixed(2) * (1 - (productData.discount / 100)).toFixed(2) :
                wholesaleItem.price * (1 - (branchData.discount / 100)).toFixed(2)
              ).toLocaleString()):
              productData.discount ?
              Math.ceil(wholesaleItem.price * (1 - (productData.discount / 100)).toFixed(2) ).toLocaleString() :
              wholesaleItem.price.toLocaleString()
               }}</strong>
              <span>{{ $t('general.egy_pounds') }}</span>/{{ $t('user.one_piece') }}  {{ shippingPriceDisplay }}
            </div>
          </div>
        </div>
        <!-- If Offer type -->
        <div v-else-if="productTypeId === 'offer' && offerDetailsArray && offerDetailsArray.length > 0"
          class="flex flex-col mt-1.5 gap-2 md:gap-y-3">
          <div v-for="offerItem in offerDetailsArray" :key="offerItem.id"
            class="flex flex-wrap items-center py-3 px-4 gap-1.5 md:gap-2 text-[0.8rem] md:text-[0.9rem] lg:text-[1rem] 3xl:text-[1.125rem] bg-primaryLight3 text-primary rounded-[0.625rem]">
            <span>{{ $t('user.offer_description_pt1', { quantity: arabizeNumbers(offerItem.quantity) }) }}</span>
            <span class="text-primary">{{ $t('user.offer_description_pt2', {
              newPrice:
                arabizeNumbers( branchData.discount ?
                Math.ceil(
                  productData.discount ?
                  offerItem.new_price * (1 - (productData.discount / 100)).toFixed(2) * (1 - (branchData.discount / 100)).toFixed(2) :
                  offerItem.new_price * (1 - (branchData.discount / 100)).toFixed(2)
                ).toLocaleString():
                productData.discount ?
                Math.ceil(offerItem.new_price * (1 - (productData.discount / 100)).toFixed(2) ).toLocaleString() :
                offerItem.new_price.toLocaleString()
              )
            }) }}</span>
            <!-- <span class="text-primary">{{ $t('user.offer_description_pt2', {
              newPrice:
              arabizeNumbers(priceAfterSelectingBranch).toLocaleString()
            }) }}</span> -->
            <span>{{ $t('user.offer_description_pt3') }}</span>
            <span class="text-[#FF1F00] discount-line after:bg-[#FF1F00]">{{ arabizeNumbers(offerItem.old_price)
              }}</span> {{ " " }}
            <span class="text-[#FF1F00]">{{ $t('general.egy_pounds') }}</span>
            <span class="text-black"> {{ shippingPriceDisplay }}</span>
          </div>
        </div>
        <!-- If Retail type-->
        <div v-else class="flex flex-col mt-1.5 py-3 px-4 gap-0.5 bg-primaryLight3 text-primary rounded-[0.625rem]">
          <!-- price will be determined later -->
          <div v-if="willPriceBeDeterminedLater">
            <span>{{ $t('general.price_will_be_specificed_later') }} {{ shippingPriceDisplay }}</span>
          </div>
          <!-- actual price -->
          <div v-else-if="updatedPrice > 0" class="flex flex-wrap items-center gap-1.5 md:gap-2">
            <span class="inline-flex items-center ">
              <span class="font-bold text-[1.313rem] md:text-[1.375rem] 3xl:text-[1.438rem]">{{
                arabizeNumbers(priceAfterSelectingBranch).toLocaleString() }}</span> 
                <span class="text-[1rem] md:text-[1.063rem] text-black ml-2">{{ $t('general.egy_pounds') }}</span>
                            <!-- if there is a discount -->
            <span v-if="Number(productData.discount)"
              class="flex flex-row items-center px-0.5 text-center gap-1 bg-[#a3a3a300]  rounded-[0.625rem]">
              <span
                class="text-[1.11rem] 3xl:text-[1.125rem] font-normal tracking-extrabold discount-line after:bg-[#C1C1C1] text-[#C1C1C1]">
                {{ productData.discount ? arabizeNumbers(Math.ceil(updatedPriceBeforeDiscount).toLocaleString()) :
                  arabizeNumbers(updatedPriceBeforeDiscount.toLocaleString()) }}
              </span>
              <span class="lg:text-[17px] text-sm font-bold tracking-extrabold text-primay">
                {{ $t('general.percentage_label', {
                  percentage: arabizeNumbers(
                    Number(productData.discount)).toLocaleString() }) }}
              </span>
            </span>
              <span class="text-[1rem] md:text-[1.063rem] text-black mr-2"> {{ shippingPriceDisplay }}</span>
            </span>
          </div>
          <!-- free -->
          <strong v-else-if="updatedPrice == 0">{{ $t('general.free') }} {{ shippingPriceDisplay }}</strong>
        </div>
        <small v-if="showNoteAboutPrice">{{ $t('general.price_has_changed_according_to_attributes') }}</small>
      </section>
    </div>
    <div class="space-y-1 mt-2">
      
      <!-- Governorates List -->
      <div v-if="governoratesOptions && governoratesOptions.length > 0" class="flex flex-wrap gap-x-2 gap-y-0.5 items-center text-[0.8rem] md:text-[0.813rem]">
        <img src="@/assets/icons/box_car.svg" alt
          class="w-[1.6rem] h-[1.6rem] md:w-[1.625rem] md:h-[1.625rem] ltr:scale-x-[-1]" 
          width="1.625rem"
          height="1.625rem" />
        
        <div class="flex items-center gap-2">
          <!-- Show "All Governorates" if length is 27 -->
          <span v-if="governoratesOptions.length === 27" 
                class="text-primary font-medium">
            {{ $t('general.to_all_governorates') }}
          </span>
          
          <!-- Show random 3 governorates + more if length < 27 -->
          <div v-else class="relative group">
            <div class="flex items-center gap-2">
              <span class="text-gray-700">
                {{ randomGovernorates?.displayString }}
              </span>
              <span v-if="randomGovernorates?.more" 
                    class="text-primary cursor-pointer">
                {{ productData.governorates.length > 0 ? '+' + $t('general.others') : '' }}
              </span>
            </div>

            <!-- Tooltip with remaining governorates -->
            <div v-if="randomGovernorates?.remainingGovernorates?.length > 0" 
                 class="absolute z-50 hidden group-hover:block top-full left-0 mt-2 p-3 bg-white rounded-lg shadow-lg border border-gray-100 min-w-[200px]">
              <div class="flex flex-col gap-2">
                <span v-for="gov in randomGovernorates?.remainingGovernorates" 
                      :key="gov.id"
                      class="text-gray-700 hover:text-primary transition-colors">
                  {{ gov[`name_${$i18n.locale}`] }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Governorates available prices  -->
      <div v-if="governoratesList && governoratesList.length > 0"
        class="flex flex-wrap gap-x-2 gap-y-0.5 items-center text-[0.8rem] md:text-[0.813rem]">
        <!-- <img src="@/assets/icons/box_car.svg" alt
          class="w-[1.6rem] h-[1.6rem] md:w-[1.625rem] md:h-[1.625rem] ltr:scale-x-[-1]" width="1.625rem"
          height="1.625rem" /> -->
        <span class="inline align-middle">{{ $t("user.delivary_price") }}</span>

        <!-- Delivary locations for is not login Users -->
        <div v-if="isNotLoggedIn" class="flex flex-wrap gap-1 items-center governorate--list">
          <span v-if="governorateDeliveries.length > 0 && isNotLoggedIn" @click="() => { displayPricesModal(); }" class="py-[0.220rem] governorates text-primary decoration-primary hover:cursor-pointer hover:shadow-primary hover:shadow-primary/50">
            {{ $t('user.governorates_prices_available') }}
          </span>
        </div>
        <!-- User login and not have is_user_address and not have addresses -->
      <div v-else-if="!isNotLoggedIn && addressesList.length === 0" class="flex items-center gap-1">
            <!-- <span v-if="randomGovernorates?.displayString" class="text-gray-500">
                {{ randomGovernorates.displayString }}
            </span>
            <span v-if="randomGovernorates?.more" class="text-primary">
              + {{ $t('general.others') }}
            </span> -->
          <span @click.prevent="() => { displayPricesModal(); }" class="py-[0.220rem] governorates text-primary decoration-primary hover:cursor-pointer hover:shadow-primary hover:shadow-primary/50 flex items-center gap-1">
            {{ $t('user.governorates_prices_available') }}
            <svg 
              :class="{'ltr:rotate-180': $i18n.locale === 'en'}"
              class="w-4 h-4 transition-transform inline-block" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg">
              <path 
                d="M15 19L8 12L15 5" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
            </svg>
          </span>
          <div 
            @click.prevent="() => { showAddressModal = true; selectedAddress = {}; }" 
            class="flex flex-row"
          >
            <span class="text-primary cursor-pointer">
              {{ $t('user.address_to_more_accurate_prices') }}
            </span>
          </div>
      </div>
      <!-- User Login and have addresses and have is_user_address -->
      <!-- <div v-else-if="haveAddresses && !isNotLoggedIn && addressesList.length > 0" class="flex flex-col gap-2"> -->
        <div v-else-if="haveAddresses && !isNotLoggedIn && addressesList.length > 0" class="flex flex-wrap gap-1 items-center governorate--list">
        <!-- Random Governorates -->
        <!-- <div v-if="randomGovernorates" class="flex flex-wrap items-center gap-3">
          <span v-if="randomGovernorates?.displayString" class="text-gray-700 font-medium">
            {{ randomGovernorates?.displayString }}
          </span>
          <span v-if="randomGovernorates?.more" class="text-primary font-medium hover:text-primary/80 cursor-pointer transition-colors duration-200">
            + {{ $t('general.others') }}
          </span>
          <div class="flex flex-wrap items-center gap-4">
            <div class="flex items-center gap-3 py-2 px-4 bg-gray-50 rounded-lg shadow-sm">
              <span v-for="(governorate, govIndex) in governorateDeliveries" :key="govIndex">
                <template v-for="area in governorate.areas" :key="area.id">
                  <span v-if="parseInt(area.price) === 0" 
                        class="text-primary font-medium hover:text-primary/90 transition-colors duration-200">
                    {{ $t('general.areas_prices_pound_without_price', { price: $t('general.free_shipping') }) }}
                  </span>
                  <span v-else-if="parseInt(area.price) === -1" 
                        class="text-primary font-medium hover:text-primary/90 transition-colors duration-200">
                    {{ $t('general.areas_prices_pound_without_price', { price: $t('general.according_agreement') }) }}
                  </span>
                  <span v-else class="font-medium text-gray-800">

                     {{ $t('general.areas_prices_pound', { price: area.price }) }}
                  </span>
                </template>
              </span>
            </div>

            <button @click.prevent="displayAddressModal" 
                    class="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors duration-200 font-medium group">
              <span>{{ $t('user.switch_another_address') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" 
                   class="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" 
                   viewBox="0 0 20 20" 
                   fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </button>
          </div>
        </div> -->
        <span v-for="(governorate, govIndex) in governorateDeliveries" :key="govIndex" 
              class="py-[0.220rem] governorates text-gray-500">
          <template v-for="area in governorate.areas" :key="area.id">
            <span v-if="parseInt(area.price) === 0" class="text-primary">{{ $t('general.free_shipping') }}</span>
            <span v-else-if="parseInt(area.price) === -1" class="text-primary">{{ $t('general.according_agreement') }}</span>
            <span v-else>{{ area.price + ' ' + $t('general.egy_pounds') }}</span>
            - {{ $t('user.for_address') }}
            {{ getAddressFormatted }}
          </template>
        </span>
        <span @click.prevent="() => { displayAddressModal(); }" class="text-primary mr-4 cursor-pointer hover:text-primary/80 hover:shadow-primary hover:shadow-primary/50">
          {{ $t('user.switch_another_address') }}
        </span>

        <!-- Shipping Price & Address -->
      </div>

        <!-- User login and have address but not have is_user_address -->
      <div v-else-if="!haveAddresses && !isNotLoggedIn && addressesList.length > 0" class="flex flex-wrap gap-1 items-center governorate--list">
           <!-- <span v-if="randomGovernorates?.displayString" class="text-gray-500">
                {{ randomGovernorates.displayString }}
            </span>
            <span v-if="randomGovernorates?.more" class="text-primary">
              + {{ $t('general.others') }}
            </span> -->
        <span @click.prevent="() => { showAddressModal = true; selectedAddress = {}; }" class="text-gray-500 mr-1 cursor-pointer hover:text-primary/80 hover:shadow-primary hover:shadow-primary/50">
          {{$t('user.this_product_is_not_available_in_your_address_click_to_add_another_address') }}
        </span>
        <span @click.prevent="() => { displayAddressModal(); }" class="text-primary mr-4 cursor-pointer hover:text-primary/80 hover:shadow-primary hover:shadow-primary/50">
          {{ $t('user.switch_another_address') }}
        </span>
      </div>
      </div>
      <!-- SKU -->
      <div v-if="productData.sku" class="flex items-center gap-1">
        <span class="text-[0.9rem] md:text-[0.9rem] 3xl:text-[1rem] mb-2">{{ $t('user.sku_product_code', {
          code:
            productData.sku
        }) }}</span>
        <button @click="formatMessage" class="text-primary !outline-none hover:brightness-110 duration-150 ease-linear flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
      </div>
      <!-- Description -->
      <div class="">
        <div class="block text-[0.813rem] md:text-[0.865rem] 3xl:text-[0.875rem] text-black font-bold">{{
          $t('user.product_description') }}</div>

        <TruncateText :text="productData[finalizedDescriptionKey]" :limit="descriptionCharactersLimit"
          class="mt-1 text-[13.7px] md:text-[14.7px] font-normal"
          appendedClass="text-[#a6a4a4] leading-[1.6] multi-lines-text" :addTruncateLabel="false">
          <template #toggle-button="{ isExpanded, toggle }">
            <button class="text-primary !outline-none hover:brightness-110 duration-150 ease-linear" @click="toggle">
              {{ isExpanded ? $t('general.show_less') : $t('general.show_more') }}
            </button>
          </template>
        </TruncateText>
      </div>
    </div>

    <Divider v-if="groupedByParentsAttributes && groupedByParentsAttributes.length > 0" class="mt-2 md:mt-3 xl:mt-3.5" />

    <!-- Specifications (attributes) -->
    <div v-if="groupedByParentsAttributes && groupedByParentsAttributes.length > 0" class="mt-3.5">
      <div class="block text-[0.813rem] md:text-[0.865rem] 3xl:text-[0.875rem] text-black font-bold">{{ $t('user.specs')
        }}</div>
      <ul v-if="groupedByParentsAttributes && groupedByParentsAttributes.length > 0"
        class="flex flex-col gap-[0.200rem] text-[0.8rem] md:text-[0.813rem] [&>li:last-child]:border-b-0">
        <Attribute :selectedAttributes="selectedAttributes" :addToSelectedAttributes="addToSelectedAttributes"
          v-for="(attrItem, index) in groupedByParentsAttributes" :key="(attrItem && attrItem.id) ? attrItem.id : index"
          :item="attrItem" />
      </ul>
    </div>

    <Divider class="mt-1" />

    <!-- Store -->
    <div v-if="shouldShowStoreSection" class="mt-2.5 md:mt-3.5 gap-3 bg-primaryLight3 rounded-[0.5rem]">
      <div class="px-4 pt-1.5 pb-[15px]">
        <div class="flex justify-between">
          <!-- Right Section -->
          <div class="flex flex-col gap-2">
            <!-- Sold From -->
            <div class="text-[0.8rem] md:text-[0.813rem]">
              {{ $t('user.store_details') }}
            </div>
            
            <!-- Store Logo & Name -->
            <div class="flex items-center gap-2.5">
              <div class="shrink-0 w-[2.9rem] h-[2.9rem] md:w-[3rem] md:h-[3rem]">
                <NuxtLink :to="storeLink" class="relative">
                  <img v-if="!!storeData.verified" 
                       src="@/assets/icons/verify_white.svg"
                       class="absolute top-0 rtl:right-0 w-[0.941rem] h-[0.941rem]" 
                       alt="verification" 
                       :width="15"
                       :height="15" />
                  <img :src="storeData.logo" 
                       @error="onImageError" 
                       alt 
                       :width="46" 
                       :height="46"
                       class="w-full h-full object-cover rounded-full" />
                </NuxtLink>
              </div>
              <div class="flex flex-col">
                <div class="flex items-center gap-2">
                  <NuxtLink :to="storeLink" class="hover:text-primary transition-colors duration-150 ease-linear">
                    <h3 class="text-[0.82rem] md:text-[0.84rem] lg:[0.87rem] 3xl-[0.875rem]">
                      {{ storeData.name || 'unknown' }}
                    </h3>
                  </NuxtLink>
                  <!-- Warning Icon -->
                  <button
                    v-if="shouldShowWarningIcon"
                    type="button"
                    @click.stop="openWarningModal"
                    class="flex items-center justify-center w-6 h-6 text-base leading-none text-yellow-500 hover:text-yellow-600 transition-colors cursor-pointer"
                    :title="$t('panel.warning_details') || 'Warning details'"
                    aria-label="warning-details"
                  >
                    ⚠️
                  </button>
                </div>

                <div class="flex w-fit items-center gap-2 bg-primary border border-primary text-white px-3 py-1.5 rounded-full mt-1">
                  <a :href="`tel:${storeData.phone}`" class="text-[0.813rem] cursor-pointer">{{ storeData.phone?.replace('+2', '') }}</a>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.31 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z" fill="currentColor"/>
                  </svg>
                </div>

                <!-- Address -->
                <div v-if="storeData.address" class="mt-2 inline-flex gap-1 break-words" style="overflow-wrap: anywhere;">
                  <img src="@/assets/icons/location.svg"
                      class="w-[0.85rem] md:w-[0.9rem] lg:w-[1rem] h-[1rem] object-contain" 
                      alt 
                      :width="14" 
                      :height="14" />
                  <NuxtLink v-if="storeData.map_url" :to="storeData.map_url" target="_blank" class="inline-block text-[0.813rem] hover:text-primary cursor-pointer">
                    {{ storeData.address + ' (' + storeData.area[`name_${usedCookieLanguage}`] + ',' + storeData.area.governorate[`name_${usedCookieLanguage}`] + ')' }}
                  </NuxtLink>
                  <span v-else class="inline-block text-[0.813rem]">
                    {{ storeData.address + ' (' + storeData.area[`name_${usedCookieLanguage}`] + ',' + storeData.area.governorate[`name_${usedCookieLanguage}`] + ')' }}
                  </span>
                </div>
              </div>
            </div>

          </div>

          <!-- Left Section -->
          <div class="flex flex-col items-end gap-4">
            <!-- Hashtags -->
            <transition name="hashtag">
              <div v-if="randomHashtag" class="mt-2 flex items-center gap-1 bg-white border border-green-500 text-black px-2 py-0.5 rounded-full hashtag-transition">
                <span class="text-[0.75rem] font-medium">{{ randomHashtag.name }}</span>            
              </div>
            </transition>

            <!-- Ratings -->
            <div class="flex items-center gap-1.5" >
              <div class="flex items-center gap-1.5 bg-white text-black px-2 py-1 rounded-full cursor-pointer" 
                   v-if="Number(storeData.ratings_avg) > 0"
                   @click="changeStoreCommentsModalState(true)">
                <span class="text-[0.9rem] md:text-[0.9rem] 3xl:text-[1rem]">{{ Number(storeData.ratings_avg || 0).toFixed(1) }}</span>
                <StarRating maxStars="1" rating="1" sizesClass="mt-0.5 w-[0.9rem] h-[0.9rem] md:w-[1rem] md:h-[1rem] mb-0.5" />
              </div>
              <!-- Followers -->
              <div class="flex items-center gap-1.5 bg-white text-black px-2 py-1 rounded-full cursor-pointer" v-if="Number(storeData.followers_count) > 0" @click="$router.push(`${ROUTESNAMES.user.followers}?storeId=${storeData.id}`)">
                <span class="text-[0.9rem] md:text-[0.9rem] 3xl:text-[1rem]">{{ storeData.followers_count || 0 }}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="blue" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
                  <path d="M12 12.75C8.83 12.75 6.25 10.17 6.25 7C6.25 3.83 8.83 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C9.66 2.75 7.75 4.66 7.75 7C7.75 9.34 9.66 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75Z" fill="blue"/>
                  <path d="M20.5901 22.75C20.1801 22.75 19.8401 22.41 19.8401 22C19.8401 18.55 16.3202 15.75 12.0002 15.75C7.68015 15.75 4.16016 18.55 4.16016 22C4.16016 22.41 3.82016 22.75 3.41016 22.75C3.00016 22.75 2.66016 22.41 2.66016 22C2.66016 17.73 6.85015 14.25 12.0002 14.25C17.1502 14.25 21.3401 17.73 21.3401 22C21.3401 22.41 21.0001 22.75 20.5901 22.75Z" fill="blue"/>
                </svg>
              </div>
            </div>

            <!-- Action Icons -->
            <div class="flex items-center gap-2 mb-2">
              <button :class="`${isCreatingChat ? 'disabled' : ''} !outline-none`.trim()" 
                      :disabled="isCreatingChat"
                      @click="() => handleResellerChat()">
                <ChatIcon class="w-[1.25rem] h-auto hover:translate-y-[-2px] linear duration-200" />
              </button>
              <button v-if="whatsappNumber" 
                      @click="handleWhatsAppClick" 
                      class="!outline-none">
                <WhatsappIcon class="w-[1.25rem] h-auto hover:translate-y-[-2px] linear duration-200" />
              </button>
              <button @click="() => { handleWhatsAppClick(); triggerContactPixelEvent(); }" 
                      v-if="storeData.phone"
                      class="!outline-none">
                <PhoneIcon class="w-[1.25rem] h-auto hover:translate-y-[-2px] linear duration-200" />
                <span class="sr-only">call {{ storeData.phone }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add the UserStoreCommentsModal component here -->
    <UserStoreCommentsModal 
      v-if="storeData && storeData.ratings_avg > 0" 
      :ratingData="productData" 
      :isModalOpen="isStoreCommentsModalOpen"
      :isUpdateDataStore="isFetchingStoreData" 
      :changeModalState="changeStoreCommentsModalState"
      :directUserToLoginPage="directUserToLoginPage" 
      :refreshStoreData="getComments" 
    />
    
    <!-- Footer Buttons -->
    <div class="flex w-full items-center px-4 py-3 gap-3">
      <button @click="() => { handleFollowStore() }" class="flex-1 flex items-center justify-center gap-2 bg-white border border-primary text-primary px-4 py-2 rounded-full text-[0.813rem] hover:bg-primary/5 transition-colors">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12.75C8.83 12.75 6.25 10.17 6.25 7C6.25 3.83 8.83 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C9.66 2.75 7.75 4.66 7.75 7C7.75 9.34 9.66 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75Z" fill="currentColor"/>
          <path d="M20.5901 22.75C20.1801 22.75 19.8401 22.41 19.8401 22C19.8401 18.55 16.3202 15.75 12.0002 15.75C7.68015 15.75 4.16016 18.55 4.16016 22C4.16016 22.41 3.82016 22.75 3.41016 22.75C3.00016 22.75 2.66016 22.41 2.66016 22C2.66016 17.73 6.85015 14.25 12.0002 14.25C17.1502 14.25 21.3401 17.73 21.3401 22C21.3401 22.41 21.0001 22.75 20.5901 22.75Z" fill="currentColor"/>
        </svg>
        {{ storeData?.following ? $t('general.unfollow_store') : $t('general.follow_store') }}
      </button>
      <NuxtLink :to="storeLink" class="flex-1">
        <button class="w-full flex items-center justify-center gap-2 bg-white border border-primary text-primary px-4 py-2 rounded-full text-[0.813rem] hover:bg-primary/5 transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.17004 7.44L12 12.55L20.77 7.47" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 21.61V12.54" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.39001 9.17999C2.39001 7.78999 3.38 6.11002 4.59 5.44002L9.93001 2.47C11.07 1.84 12.94 1.84 14.08 2.47L19.42 5.44002C20.63 6.11002 21.62 7.78999 21.62 9.17999V14.82C21.62 16.21 20.63 17.89 19.42 18.56L14.08 21.53C12.94 22.16 11.07 22.16 9.93001 21.53L4.59 18.56C3.38 17.89 2.39001 16.21 2.39001 14.82V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('general.all_products') }} ({{ storeData?.products_count}})
        </button>
      </NuxtLink>
    </div>

    <!-- store branch -->
    <!-- for free -->
    <span v-if="isFree" class="mt-2 inline-block">{{ $t('general.free') }}</span>
    <!-- branch's actual price -->
    <div v-else class="bg-[#ffffff] pt-5 pb-0 rounded-lg mt-3 flex flex-col gap-2">
      <h2
        v-if="productData.branches.length > 0"
        class="font-bold text-[0.813rem] md:text-[0.865rem] 3xl:text-[0.875rem] mb-1 md:mb-2 ellipsis-x2 text-[#6A6A6A]">
        {{
          $t('general.choose_branch') }}</h2>
      <!-- main branch -->

      <section v-if="productData.branches.length > 0" class="branch-container">
        <div class="flex justify-between items-center border border-[#E5E5E5] rounded-[0.5rem] w-full p-2 md:p-3">
          <div class="flex flex-wrap items-center w-full">
            <label for="default-radio-1"
              class="basis-[35%] ml-2 text-[0.8rem] md:text-[0.813rem] font-normal text-gray-900">
              {{ $t('general.main_branch') }}
            </label>
            <div class="basis-[60%] flex justify-between items-center w-full">
              <p class="text-[0.885rem] md:text-[0.95rem] 3xl:text-base font-normal text-black">
                <span v-if="productTypeId === 'wholesale'">{{ $t('user.starts_from', {
                  price:
                    (Number(productData.discount)
                      && productData.discount > 0) ?
                      arabizeNumbers(Math.ceil(Number(updatedPrice * (1 + (0 / 100))).toFixed(2)).toLocaleString()) :
                      arabizeNumbers(Number(updatedPrice * (1 + (0 / 100))).toFixed(2).toLocaleString())} ) }} / {{
                    $t('user.one_piece')
                  }}</span>

                <span v-if="productTypeId === 'offer'">

                  {{ $t('user.offer_description_pt1', {
                    quantity: arabizeNumbers(productData?.offer_details?.[0]?.quantity)
                  }) }}
                  {{ $t('user.offer_description_pt2', {
                    newPrice:
                      (Number(productData.discount) && productData.discount > 0) ?
                        arabizeNumbers(Math.ceil(Number(updatedPrice * (1 + (0 / 100))).toFixed(2)).toLocaleString()) :
                        arabizeNumbers(Number(updatedPrice * (1 + (0 / 100))).toFixed(2).toLocaleString())
                  }) }}
                  {{ $t('user.offer_description_pt3') }}
                  <span class=" line-through"> {{ arabizeNumbers(productData?.offer_details?.[0]?.old_price) }} </span>
                  {{ $t('general.egy_pounds') }}
                </span>

                <span v-if="productTypeId === 'retail'" class="sm:text-[.75rem] text-[.65rem] font-normal"> {{
                  (Number(productData.discount) && productData.discount > 0) ?
                    arabizeNumbers(Math.ceil(Number(updatedPrice * (1 + (0 / 100))).toFixed(2)).toLocaleString()) :
                    arabizeNumbers(Number(updatedPrice * (1 + (0 / 100))).toFixed(2).toLocaleString())}} {{ $t('general.egy_pounds')
                  }}</span>
              </p>
            </div>
          </div>
          <input id="default-radio-1" v-model="branchId" type="radio" :value="`main`" name="default-radio"
            class="focus:ring-0" @change="() => onBranchChange('main')" />
        </div>
      </section>

      <!-- other branches -->
      <section class="branch-container">
        <div v-for="branch in productData.branches" :key="branch.id"
          class="flex justify-between items-center border border-[#E5E5E5] rounded-[0.5rem] w-full p-2 md:p-3">
          <div class="flex flex-wrap items-center w-full">
            <label for="default-radio-1"
              class="basis-[35%] ml-2 text-[0.8rem] md:text-[0.813rem] font-normal text-gray-900">
              {{ branch.name }}
            </label>
            <div class="basis-[60%] flex items-center gap-2 md:gap-2.5 w-full">
              <p class="text-[0.885rem] md:text-[0.95rem] 3xl:text-base font-normal text-black">


                <span v-if="productTypeId === 'wholesale'">{{ $t('user.starts_from', {
                  price: branch.discount ?
                    arabizeNumbers(
                      Math.ceil(Number(updatedPrice * (1 + (-branch.discount / 100)))
                      ).toLocaleString()) : arabizeNumbers(
                        Number(updatedPrice * (1 + (0 / 100))
                        ).toLocaleString())} ) }} / {{ $t('user.one_piece') }}</span>


                <span v-if="productTypeId === 'retail'" class="sm:text-[.75rem] text-[.65rem] font-normal"> {{
                  branch.discount ? arabizeNumbers(
                    Math.ceil(Number(updatedPrice * (1 + (-branch.discount / 100)))
                    ).toLocaleString()) : arabizeNumbers(
                      Number(updatedPrice * (1 + (0 / 100))
                  ).toLocaleString())}} {{ $t('general.egy_pounds') }}</span>

                <span v-if="productTypeId === 'offer'">

                  {{ $t('user.offer_description_pt1', {
                    quantity: arabizeNumbers(productData?.offer_details?.[0]?.quantity)
                  }) }}
                  {{ $t('user.offer_description_pt2', {
                    newPrice:
                    branch.discount  ?
                        arabizeNumbers(Math.ceil(Number(updatedPrice * (1 + (-branch.discount / 100)))).toLocaleString()) :
                        arabizeNumbers(Number(updatedPrice * (1 + (0 / 100))).toLocaleString())
                  }) }}
                  {{ $t('user.offer_description_pt3') }}
                  <span class=" line-through"> {{ arabizeNumbers(productData?.offer_details?.[0]?.old_price) }} </span>
                  {{ $t('general.egy_pounds') }}
                </span>


              </p>
              <p
              v-if="productTypeId === 'retail'"
                :class="`text-[0.813rem] md:text-[0.865rem] 3xl:text-[0.875rem] font-bold text-left  ${branch.discount > 0 ? 'text-[#27a150]' : 'text-primary'} `">

                {{ branch.discount > 0 ?
                  `${$t('general.discount_value', { percentage: branch.discount })}`
                  :
                  branch.discount == 0 ?
                    ``
                    :
                    `${$t('general.discount_value', { percentage: branch.discount })}`
                }}
              </p>
            </div>
          </div>
          <!-- the branch id should be placed inside the parent component to be accessed from the outside -->
          <input id="default-radio-1" v-model="branchId" type="radio" :value="branch.id" name="default-radio"
            class="focus:ring-0" @change="(e) => onBranchChange(branch)" />
        </div>
      </section>
    </div>
    <Divider v-if="productData.warnings && productData.warnings.length > 0" class="mt-2 md:mt-3 xl:mt-3.5" />
    <!-- Warning Security Section -->
     <div v-if="productData.warnings && productData.warnings.length > 0" class="mt-6">
      <div class="flex flex-col gap-2.5">
        <h3 class="font-bold text-[0.938rem] md:text-[1rem] text-black flex items-center gap-2">
          {{ $t('general.security_warnings') }}
        </h3>
        <ul class="list-disc list-inside space-y-2.5 pl-1">
          <li v-for="(warning, index) in productData.warnings" 
              :key="index" 
              class="text-[0.875rem] md:text-[0.925rem] text-black leading-relaxed">
            {{ warning }}
          </li>
        </ul>
      </div>
    </div>
    
    <!-- Actions -->
    <div
      class="md:text-[17px] grid grid-cols-[repeat(auto-fit,minmax(12.563rem,1fr))] max-w-[42.689rem] mx-auto justify-items-center gap-2 sm:gap-4 md:gap-[1.40rem] xl:gap-[1.5rem] 2xl:gap-[1.550rem] mt-5 md:mt-7">
      <!-- chat the reseller  -->
      <button :disabled="isCreatingChat" @click="() => changeContactResellerModalState(true)"
        :class="`${isCreatingChat ? 'disabled' : ''} flex gap-3 cursor-pointer hover:opacity-90 items-center whitespace-nowrap justify-center hover:brightness-105 duration-150 transition-all bg-primary disabled:bg-[#163487] text-white py-[0.450rem] px-4 md:py-[0.61rem] 3xl:py-2.5 w-full text-[13px] sm:text-[15px] md:text-[15.3px] lg:text-[15.8px] 3xl:text-[17px] font-bold rounded-[0.625rem]`">
        <span>{{ $t('user.reseller_chat') }}</span>
        <Chat />
      </button>
      <!-- order the product  -->
      <button :disabled="isLoading" @click="() => changeOrderMethodModalState(true)"
        :class="`${isLoading ? 'disabled' : ''} flex gap-3 cursor-pointer hover:opacity-90 items-center whitespace-nowrap justify-center hover:brightness-105 duration-150 transition-all bg-primary disabled:bg-[#163487] text-white py-[0.450rem] px-4 md:py-[0.61rem] 3xl:py-2.5 w-full text-[13px] sm:text-[15px] md:text-[15.3px] lg:text-[15.8px] 3xl:text-[17px] font-bold rounded-[0.625rem]`">
        <!-- <Plus /> -->
        <span>{{ $t('user.order_product') }}</span>
        <div class="w-5 h-5 rounded-full bg-white grid place-items-center">
          <img :src="plusImg" class="w-3" alt="">
        </div>
      </button>
      <!-- add to cart -->
      <button :disabled="isAddingToCart" @click="() => createOrder(true)"
        :class="`${isAddingToCart ? 'disabled' : ''} flex gap-3 cursor-pointer hover:opacity-90 items-center whitespace-nowrap justify-center hover:brightness-105 duration-150 transition-all bg-primary disabled:bg-[#163487] text-white py-[0.450rem] px-4 rtl:md:py-[0.61rem] 3xl:py-2.5 w-full text-xs rtl:text-[12.5px] ltr:text-[15px] rtl:md:text-[13px] ltr:md:text-[15.5px] rtl:lg:text-[14px] ltr:lg:text-[16px] 3xl:text-[16.5px] font-bold rounded-[0.625rem]`">
        <span>{{ $t('user.add_to_cart') }}</span>
        <AddToCartIcon />
      </button>
    </div>
    <GoogleAdsBanner v-if="productData?.category?.id != '383'" />
    <!-- order method modal -->
    <Modal :isOpen="isOrderMethodModalOpen" :changeModalState="changeOrderMethodModalState" :modalTitle="''"
      :hideHeadersBorder="true">
      <!-- title -->
      <template v-if="governoratesOptions.length === 0 && isAvailableProduct">
        <h3 class="mx-auto text-center text-sm sm:text-xl font-semibold text-red-500 -mt-5 mb-2">
          {{ $t('general.product_not_available_for_delivery') }}
        </h3>
        <p class="mx-auto text-center text-sm sm:text-[16px] text-gray-900 mb-8">
          {{ $t('general.product_not_available_for_delivery_description') }}
        </p>
      </template>
      <template v-else-if="governoratesOptions.length === 0 && !isAvailableProduct">
        <h3 class="mx-auto text-center text-sm sm:text-xl font-semibold text-red-500 -mt-5 mb-8">
          {{ $t('general.this_product_is_not_available') }}
        </h3>
        <p class="mx-auto text-center text-sm sm:text-[16px] text-gray-900 mb-8">
          {{ $t('general.product_not_available_for_delivery_description') }}
        </p>
      </template>
      <template v-else-if="governoratesOptions.length > 0 && !isAvailableProduct">
        <h3 class="mx-auto text-center text-sm sm:text-xl font-semibold text-red-500 -mt-5 mb-8">
          {{ $t('general.this_product_is_not_available') }}
        </h3>
        <p class="mx-auto text-center text-sm sm:text-[16px] text-gray-900 mb-8">
          {{ $t('general.product_not_available_for_delivery_description') }}
        </p>
      </template>
      <template v-else>
        <h3 class="mx-auto text-center text-sm sm:text-xl font-semibold text-gray-900 -mt-5 mb-2">
          {{ $t('general.choose_order_method') }}
        </h3>
        <p class="mx-auto text-center text-sm sm:text-[16px] text-gray-900 mb-8">
          {{ $t('general.order_through_merchant') }}
        </p>
      </template>
       
        <!-- order from the merchant  -->
        <div class="flex items-baseline justify-center gap-[35px] mb-8">
          <!-- chat -->
<div class="flex flex-col justify-center items-center gap-3">
  <button :class="`${isCreatingChat ? 'disabled' : ''} bg-[#0963FF1A] rounded-full w-[47px] aspect-square flex items-center justify-center !outline-none px-1`.trim()" :disabled="isCreatingChat"
              @click="() => handleResellerChat()">
              <ChatIcon class="w-[1.625rem] 3xl:w-[1.68rem] h-auto hover:translate-y-[-2px] linear duration-200" />
            </button>
            <span>{{ $t('general.chat') }}</span>
</div>
        <!-- whatsapp  -->
        <div class="flex flex-col justify-center items-center gap-3">
            <a :href="formattedWhatsappLink" class="bg-[#0963FF1A] rounded-full w-[47px] aspect-square flex items-center justify-center !outline-none px-1" target="_blank">
              <WhatsappIcon class="w-[1.625rem] 3xl:w-[1.68rem] h-auto hover:translate-y-[-2px] linear duration-200" />
            </a>
            <span>{{ $t('general.the_whatsapp') }}</span>
            </div>
            <!-- phone -->
            <div class="flex flex-col justify-center items-center gap-3">
            <a :href="`tel:${storeData.phone}`" @click="triggerContactPixelEvent" v-if="storeData.phone"
              class="bg-[#0963FF1A] rounded-full w-[47px] aspect-square flex items-center justify-center !outline-none px-1">
              <PhoneIcon class="w-[1.5rem] 3xl:w-[1.56rem] h-auto hover:translate-y-[-2px] linear duration-200" />
              <span class="sr-only">call {{ storeData.phone }}</span>
            </a>
            <span>{{ $t('general.just_phone') }}</span>

            </div>
          </div>

      <section 
        v-if="isAvailableProduct && governoratesOptions.length > 0" 
        class="flex flex-col justify-center items-center gap-3 pt-0 pb-9 px-4 mt-[20px]">
        <p class="text-center text-sm text-gray-500 mb-4 bg-gray-50 p-4 rounded-lg mb-0">{{ $t('general.or') }}</p>
        <button :disabled="isLoading" @click="() => createOrder()"
          :class="`${isLoading ? 'disabled' : ''} w-full h-[55px] max-w-[360px] py-[12px] flex gap-3 cursor-pointer hover:opacity-90 items-center whitespace-nowrap justify-center hover:brightness-105 duration-150 transition-all bg-primary disabled:bg-[#163487] text-white px-6 md:py-2 3xl:py-2 md:px-7 lg:px-8 text-xs sm:text-[15px] md:text-[15.5px] lg:text-[16px] font-bold rounded-[8px]`">
          <span>{{ $t('general.order_method') }}</span>
        </button>
      </section>
    </Modal>

    <!-- Contact Reseller Modal -->
    <Modal :isOpen="isContactResellerModalOpen" :changeModalState="changeContactResellerModalState" :modalTitle="''"
      :hideHeadersBorder="true">
      <!-- title -->
      <h3 class="mx-auto text-center text-sm sm:text-xl font-semibold text-gray-900 -mt-5 mb-8">
        {{ $t('general.contact_the_reseller') }}
      </h3>
      <p class="mx-auto text-center text-sm sm:text-[16px] text-gray-900 mb-8">
        {{ $t('general.you_can_contact_with_the_reseller_via_whatsapp_or_the_chat_of_the_website') }}
      </p>
      <!-- methods -->
      <div class="flex items-baseline justify-center gap-[35px] mb-8 pb-9">
        <!-- chat -->
        <div class="flex flex-col justify-center items-center gap-3">
          <button 
            :class="`${isCreatingChat ? 'disabled' : ''} bg-[#0963FF1A] rounded-full w-[47px] aspect-square flex items-center justify-center !outline-none px-1`.trim()" 
            :disabled="isCreatingChat"
            @click="() => { changeContactResellerModalState(false); handleResellerChat(); }">
            <ChatIcon class="w-[1.625rem] 3xl:w-[1.68rem] h-auto hover:translate-y-[-2px] linear duration-200" />
          </button>
          <span>{{ $t('general.chat') }}</span>
        </div>
        <!-- whatsapp  -->
        <div class="flex flex-col justify-center items-center gap-3">
          <a 
            :href="formattedWhatsappLink" 
            @click="() => changeContactResellerModalState(false)"
            class="bg-[#0963FF1A] rounded-full w-[47px] aspect-square flex items-center justify-center !outline-none px-1" 
            target="_blank">
            <WhatsappIcon class="w-[1.625rem] 3xl:w-[1.68rem] h-auto hover:translate-y-[-2px] linear duration-200" />
          </a>
          <span>{{ $t('general.the_whatsapp') }}</span>
        </div>
        <!-- phone -->
        <div class="flex flex-col justify-center items-center gap-3">
          <a 
            :href="`tel:${storeData.phone}`" 
            @click="() => { changeContactResellerModalState(false); triggerContactPixelEvent(); }" 
            v-if="storeData.phone"
            class="bg-[#0963FF1A] rounded-full w-[47px] aspect-square flex items-center justify-center !outline-none px-1">
            <PhoneIcon class="w-[1.5rem] 3xl:w-[1.56rem] h-auto hover:translate-y-[-2px] linear duration-200" />
            <span class="sr-only">call {{ storeData.phone }}</span>
          </a>
          <span>{{ $t('general.just_phone') }}</span>
        </div>
      </div>
    </Modal>

    <!-- Shipping Prices Modal for is not login user -->
    <client-only>
      <Modal
        v-if="isShippingPricesModalOpen"
        :isOpen="isShippingPricesModalOpen"
        :changeModalState="handleModalClose"
        :modalTitle="$t('general.shipping_prices')"
        @close="handleModalClose"
      >
        <p class="mt-4 text-center text-sm text-gray-500 mb-4 bg-gray-50 p-4 rounded-lg">{{ $t('general.shipping_prices_modal_description2') }}</p>
        <div class="shipping-prices-container">
          <div v-for="governorate in governoratesData" :key="governorate.id" class="mb-4">
            <div
              class="flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 rounded-lg cursor-pointer transition-all duration-200 hover:shadow-md"
              @click="toggleGovernorate(governorate.id)"
            >
              <div class="flex items-center gap-3">
                <div class="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                  <svg 
                    class="w-4 h-4 text-primary"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path 
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" 
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div class="flex flex-col">
                  <span class="font-medium text-gray-800 text-[0.95rem]">{{ governorate[`name_${$i18n.locale}`] }}</span>
                  <div class="flex items-center gap-1">
                    <span class="text-primary text-xs">
                      {{ $t('general.shipping_prices_modal_description') }}
                    </span>
                    <svg 
                      :class="{'rotate-180': openGovernorates.includes(governorate.id)}"
                      class="w-[25px] h-[25px] transition-transform duration-300 text-primary"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path 
                        d="M7 10L12 15L17 10" 
                        stroke="currentColor" 
                        stroke-width="2" 
                        stroke-linecap="round" 
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <span class="text-primary font-medium">
                {{ getGovernoratePrice(governorate) }}
              </span>
            </div>
            
            <div v-if="openGovernorates.includes(governorate.id)" 
                 class="mt-2 bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transform transition-all duration-200 ease-in-out">
              <div v-for="area in governorate.areas" :key="area.id" 
                   class="flex justify-between items-center p-4 border-b last:border-b-0 hover:bg-gray-50 transition-all duration-200">
                <div class="flex items-center gap-2">
                  <div class="w-1.5 h-1.5 rounded-full bg-gray-300"></div>
                  <span class="text-gray-700 text-[0.9rem]">{{ area[`name_${$i18n.locale}`] }}</span>
                </div>
                <div class="flex items-center gap-1.5">
                  <span class="font-medium text-primary text-[0.95rem]">
                    {{ formatAreaPrice(area.price) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </client-only>

    <!-- Address Modal -->
    <AddressModal
      v-if="showAddressModal"
      :show="showAddressModal"
      :address="selectedAddress"
      @close="closeAddressModal"
      @submit="handleAddressSubmit"
      :changeModalState="closeAddressModal"
      :editForm="selectedAddress"
      :isSubmitting="isSubmitting"
    />

    <!-- Address Selection Modal -->
    <Modal
      v-if="isAddressSelectionModalOpen"
      :isOpen="isAddressSelectionModalOpen"
      :changeModalState="closeAddressSelectionModal"
      :modalTitle="$t('user.select_address')"
    >
      <div v-if="isLoadingAddresses" class="loading-container"> 
        <div class="loading-spinner"></div>
      </div>
      <div v-else class="address-selection-container">
        <!-- Address Cards -->
        <AddressCard
          v-for="address in addressesList"
          :key="address.id"
          :address="address"
          @edit="openAddressModal"
          @make-default="makeDefaultAddress"
          @delete="deleteAddress"
          :hideMenu="true"
          :clickToPin="true"
        />

        <!-- Add New Address Button -->
        <div class="flex justify-center mt-6 mb-4">
          <button
            @click="() => { showAddressModal = true; selectedAddress = {}; isAddressSelectionModalOpen = false; }"
            class="flex items-center gap-2 bg-primary text-white px-6 py-2.5 rounded-lg hover:bg-primary/90 transition-colors"
          >
            <span>{{ $t('user.add_new_address') }}</span>
            <svg
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 5V19M5 12H19"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </Modal>
  </div>

</template>

<script>

import { ref, computed, watch } from "vue";
import Attribute from "./Attribute.vue";
import defaultStoreImage from "@/assets/images/default-user.svg";

import { FavoriteBtn, Modal, VerifiedIcon } from '@/components';
import WhatsappButton from "@/components/user/WhatsappButton.vue";
import TruncateText from "@/components/generic/TruncateText.vue";
import Divider from "./Divider.vue";
// Icons
import Phone from "@/assets/shared/icons/Phone.vue";
import Star from "@/assets/shared/icons/Star.vue";
import Chat from "@/assets/shared/icons/Chat.vue";
import Plus from "@/assets/shared/icons/Plus.vue";
import AddToCartIcon from "@/assets/shared/icons/AddToCart.vue";
import ChatIcon from "@/assets/shared/icons/ChatOutline.vue";
import WhatsappIcon from "@/assets/shared/icons/WhatsappOutline.vue";
import PhoneIcon from "@/assets/shared/icons/PhoneOutline.vue";
import CaretLeftIcon from "@/assets/shared/icons/CaretLeftIcon.vue";
import plusImg from "@/assets/images/plus.svg";
import StarRating from "@/components/generic/StarRating.vue";
import { mapActions, mapState } from 'pinia';
import { useGlobalStore } from "@/store/Modules/global.js";
import { generateWhatsappLink, useLocalStorage, stripAwaySpecialCharacters, buildStoreLink, roundWithHalf, arabizeNumbers, ROUTESNAMES, APIREQUESTS, MAINROLES, generateRandomId, isEmpty, onImageError } from "@/helpers";
import MakeOrderModal from "./MakeOrderModal.vue";
import OrderDetailsVue from './OrderDetails.vue';
import OfferOrderDetails from "../../user/manageOrders/OfferOrderDetails.vue";
import OrderDetailsOffer from "./OrderDetailsOffer.vue";
import WarningSecurityContactModal from "@/components/user/WarningSecurityContactModal.vue";
import AddressModal from "@/pages/addresses/components/AddressModal.vue";
import AddressCard from "@/pages/addresses/components/AddressCard.vue";
import UserStoreCommentsModal from "@/components/user/store/StoreCommentsModal.vue";
import GoogleAdsBanner from '@/components/generic/GoogleAdsBanner.vue';
import StoreWarningModal from "@/components/user/store/StoreWarningModal.vue";
export default {
  name: "product-details",
  setup(_, context) {
    const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
    // handles the condition of showing/hiding the brief-info bar when scrolling through the section (on desktop only)
    const imageScrollObserverTarget = ref(null);
    const isProductNameIntersecting = useIntersectionObserver(imageScrollObserverTarget, {
      rootMargin: '2px 0px 0px 0px',
      threshold: 0.5,
      widthToInitialize: 750
    });
    const showBriefProductInfoBar = computed(() => !isProductNameIntersecting.value);

    watch(showBriefProductInfoBar, function (val) {
      context.emit("showBriefProductInfoBar", val);
    });

    return {
      usedCookieLanguage,
      imageScrollObserverTarget,
    }
  },
  props: {
    whatsappNumber: {
      type: [String, Number, null],
      required: true,
    },
    changeShareProductModalState: {
      type: Function,
      required: true
    },
    productData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    updatedPrice: {
      type: [Number, String],
      required: true,
      default: () => 0
    },
    updatedPriceBeforeDiscount: {
      type: [Number, String],
      required: true,
      default: () => 0
    },
    addToSelectedAttributes: {
      type: Function,
      required: true,
    },
    overrideSelectedAttributes: {
      type: Function,
      required: true,
    },
    selectedAttributes: {
      type: Object,
      required: true,
      default: () => ({})
    },
    priceAfterSelectingBranch: {
      type: [Number, NaN],
      required: true,
      default: NaN
    },
    getDiscountPercentage: {
      type: [Number, NaN],
      required: false,
      default: NaN
    },
    willPriceBeDeterminedLater: {
      type: Boolean,
      default: false,
      required: true,
    },
    isNotLoggedIn: {
      type: Boolean,
      default: false,
      required: true,
    },
    isGuest: {
      type: Boolean,
      default: false,
      required: true,
    },
    isFree: {
      type: Boolean,
      default: false,
      required: true,
    },
    showNoteAboutPrice: {
      type: Boolean,
      default: false,
      required: true,
    },
    productTypeId: {
      type: [Number, String],
      required: true,
      default: ""
    },
    governoratesList: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    productType: {
      type: String,
      default: "",
      required: true,
    },
    portalPage: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    GoogleAdsBanner,
    Attribute,
    WarningSecurityContactModal,
    Phone,
    Star,
    Chat,
    Plus,
    FavoriteBtn,
    Modal,
    VerifiedIcon,
    AddToCartIcon,
    MakeOrderModal,
    WhatsappButton,
    OfferOrderDetails,
    TruncateText,
    Divider,
    StarRating,
    ChatIcon,
    WhatsappIcon,
    PhoneIcon,
    CaretLeftIcon,
    OrderDetailsVue,
    OrderDetailsOffer,
    AddressModal,
    AddressCard,
    UserStoreCommentsModal,
    StoreWarningModal,
  },
  data() {
    return {
      following: false,
      followingInProgress: false,
      hideWarningModal: false,
      addresses: [],
      countdown: 0,
      timer: null,
      governoratesOptions: [],
      WarningSecurityContactModalState: false,
      plusImg,
      ROUTESNAMES,
      isLoading: false,
      branchId: 'main',
      isCreatingChat: false,
      isAddingToCart: false,
      isOrderFormModalOpen: false,
      isOrderMethodModalOpen: false,
      isContactResellerModalOpen: false,
      descriptionCharactersLimit: 200,
      isOfferOrderDetailsModalOpen: false,
      defaultStoreImage,
      isNewOrder: true,
      maxQuantity: 0,
      branchData: {},
      isQuantityOfferModelOpen: false,
      changeQuantityOfferModalState: false,
      chosenOffer: {},
      fromCart: false,
      isShippingPricesModalOpen: false,
      openGovernorates: [],
      governoratesData: [],
      showAddressModal: false,
      selectedAddress: {},
      isSubmitting: false,
      isAddressSelectionModalOpen: false,
      addressesList: [],
      isLoadingAddresses: false,
      currentHashtagIndex: 0,
      hashtagTimer: null,
      isStoreCommentsModalOpen: false,
      isFetchingStoreData: false,
      ratingData: null,
      displayCountdown: { time: '0,0,0,0', strings: 'days,hours,minutes,seconds' },
      warningModalState: false,
      currentWarning: null,
    };
  },
  methods: {
    ...mapActions(useGlobalStore, ['updateForwardedStore', 'updateDisableChattingState']),
    
    buildStoreLink,
    onImageError,
    roundWithHalf,
    arabizeNumbers,
    stripAwaySpecialCharacters,
    changeStoreCommentsModalState(val){
      this.isStoreCommentsModalOpen = val;
    },
    handleFollowStore() {
      if (this.isNotLoggedIn) {
        this.$router.push('/login');
        return;
      }
      
      const storeId = this.storeData?.id;
      if (!storeId) return;
      let payload = {
        store_id: storeId
      }
      this.makeRequest({
        owner: MAINROLES.user,
        url: APIREQUESTS.user.followStore.url,
        method: APIREQUESTS.user.followStore.method,
        formData: JSON.stringify(payload)
      })
        .then((res) => {
          if (res.status) {
            // Toggle following state
            this.storeData.following = !this.storeData.following;
            
            // Update followers count
            if (this.storeData.following) {
              this.storeData.followers_count = (this.storeData.followers_count || 0) + 1;
            } else if (this.storeData.followers_count > 0) {
              this.storeData.followers_count -= 1;
            }
            
            this.notify({ 
              type: 'success', 
              msg: res?.message
            });
          } else {
            this.notify({ type: 'error', msg: res?.message || this.$t('general.failed') });
          }
        })
        .catch((err) => {
          this.notify({ type: 'error', msg: err?.data?.message || this.$t('general.failed') });
        });
    },
    rotateHashtags() {
      const hashtags = this.productData?.store?.hashtags || [];
      if (!hashtags.length) return;
      
      // Increment index instead of decrementing for proper rotation
      this.currentHashtagIndex = (this.currentHashtagIndex + 1) % hashtags.length;
    },

    startHashtagRotation() {
      const hashtags = this.productData?.store?.hashtags || [];
      if (!hashtags.length) return;
      
      // Only run on client side
      if (process.client) {
        // Clear any existing timer first
        this.stopHashtagRotation();
        
        // Start rotation every 2 seconds
        this.hashtagTimer = setInterval(() => {
          this.rotateHashtags();
        }, 2000);
      }
    },

    stopHashtagRotation() {
      if (this.hashtagTimer && process.client) {
        clearInterval(this.hashtagTimer);
        this.hashtagTimer = null;
      }
    },
    async getAllGovernorates() {
      try {
        const productID = this.productData.id;
        // Make the asynchronous request
        const res = await this.makeRequest({
          url: `${APIREQUESTS.user.getGovernorates.url}?product_id=${productID}`,
          method: APIREQUESTS.user.getGovernorates.method,
        });
        if (!res.status) {
          // handle error
        } else {
          const options = res?.data || [];
          this.governoratesOptions = options;
        }
      } catch (err) {
        // Handle the error
        this.notify({ type: 'error', msg: err?.data?.message });
      }
    },
    updateCountdown() {
      if (!this.productData?.offer_end_timestamp) return;
      
      const now = new Date().getTime();
      const endTime = this.productData.offer_end_timestamp * 1000;
      const timeRemaining = endTime - now;
      
      if (timeRemaining <= 0) {
        this.displayCountdown = {
          time: "0,0,0",
          strings: this.$t('general.days') + ',' + this.$t('general.hours') + ',' + this.$t('general.minutes')
        };
        this.stopCountdownTimer();
        return;
      }
      
      // Calculate all time units in descending order of magnitude
      const timeUnits = [
        { value: Math.floor(timeRemaining / (1000 * 60 * 60 * 24 * 30)), label: this.$t('general.months') },
        { value: Math.floor((timeRemaining % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24 * 7)), label: this.$t('general.weeks') },
        { value: Math.floor((timeRemaining % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24)), label: this.$t('general.days') },
        { value: Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), label: this.$t('general.hours') },
        { value: Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)), label: this.$t('general.minutes') },
        { value: Math.floor((timeRemaining % (1000 * 60)) / 1000), label: this.$t('general.seconds') }
      ];
      
      // Filter out zero values
      const nonZeroUnits = timeUnits.filter(unit => unit.value > 0);
      
      // Take the first 3 non-zero units (already in descending order)
      // If less than 3 non-zero units, use what we have
      const unitsToShow = nonZeroUnits.length > 0 
        ? nonZeroUnits.slice(0, 3) 
        : timeUnits.slice(-3);
      
      // Format the countdown display
      const timeValues = unitsToShow.reverse().map(unit => unit.value).join(',');
      const timeLabels = unitsToShow.map(unit => unit.label).join(',');
      
      this.displayCountdown = {
        time: timeValues,
        strings: timeLabels
      };
    },
    handleWhatsAppClick(){
      this.WarningSecurityContactModalState = true;
    },
    confirmAction(){
      const thePath = `${this.$route.path}/order-details`
      this.$router.push(thePath);
    },
    confirmActionForOffer(data){
      this.$emit('confirmActionForOffer',data);
      this.isQuantityOfferModelOpen = false;
    },
    changeQuantityOfferModalState(val){
      this.isQuantityOfferModelOpen = val;
      this.isOrderMethodModalOpen = false;
    },
    confirmActionForAddOffer(data){
      this.isOfferOrderDetailsModalOpen = false;
      this.$emit('confirmActionForAddOffer',data);
      this.maxQuantity = data.maxQuantity;
      this.chosenOffer = data.chosenOffer;
      localStorage.setItem('chosenOffer', JSON.stringify(this.chosenOffer));
      this.isQuantityOfferModelOpen = true;
    },
    changeOfferOrderDetailsModalState(val) {
      this.isOfferOrderDetailsModalOpen = val;
      this.isOrderMethodModalOpen = false;
    },
    createOrder(fromCart){
      if(this.governoratesOptions.length === 0){
        this.changeOrderMethodModalState(true);
        return;
      }
      
      // Check if guest user is trying to add to cart
      if(this.isNotLoggedIn && fromCart){
        this.notify({type: 'error', msg: this.$t('general.must_login_to_add_to_cart')});
        // Store return path for post-login redirect (fallback when history state is unreliable)
        const returnPath = this.$route.fullPath;
        if (returnPath) localStorage.setItem('returnAfterLogin', returnPath);
        this.$router.push('/login');
        return;
      }
      // If product is available and has governorates, and user clicked cart button, show order method modal first
      if(!this.isAvailableProduct && this.governoratesOptions.length > 0 && fromCart){
        this.changeOrderMethodModalState(true);
        return;
      }
      
      const isAuthorizedOrder = Boolean(this.storeData?.authorized_order);
      const isGuest = this.isGuest;
      const isNotLoggedIn = this.isNotLoggedIn;
      // if(!this.isNotLoggedIn && !this.haveAddresses && this.productData.governorates.length > 0){
      //   this.notify({type: 'error', msg: this.$t('user.please_add_address_available_to_order')});
      //   return;
      // }
      if(isNotLoggedIn && isAuthorizedOrder && !isGuest){
        this.notify({type: 'error', msg: this.$t('general.authorized_order_not_allowed')});
        return;
      }else{
            switch(this.productTypeId){
            case 'wholesale':
              this.changeOrderMethodModalState(true);
              useGlobalStore().setProductData(this.productData);
              this.fromCart = fromCart;
              localStorage.setItem('fromCart', fromCart);
              this.$router.push({ path: `/products/${this.productData.store.username}/${this.productData.id}/${this.productData.name_ar}/order-details` });
              break;
            case 'retail':
              this.changeOrderModalState(true);
              useGlobalStore().setProductData(this.productData);
              this.fromCart = fromCart;
              localStorage.setItem('fromCart', fromCart);
              this.changeOrderMethodModalState(false);
              break;
            case 'offer':
              localStorage.setItem('fromCart', fromCart);
              this.fromCart = fromCart;
              useGlobalStore().setProductData(this.productData);
              this.changeOfferOrderDetailsModalState(true);
              break;
              default:
                this.notify({type: 'error', msg: 'this is unknown product type'});
            } 
      }
    },
    changeOrderMethodModalState(val) {
      this.isOrderMethodModalOpen = val
    },
    changeContactResellerModalState(val) {
      this.isContactResellerModalOpen = val;
    },
    changeOrderModalState(val) {
      this.isOrderFormModalOpen = val;
    },
    openOrderFormModal(productData) {
      this.changeOrderModalState(true);
    },
    validation() {

      if (this.subAttrIds.length != this.groupedByParentsAttributes.length) {//check if user select one sub-attr at each main-attr or not 
        return false
      }
      else if (this.isBranchExist && (!this.branchId)) {//check if branchs exist and  selected or not
        return false
      }
      else {
        return true
      }
    },
    handleCreateOrder(orderForm) {
      return new Promise((resolve, reject) => {
        let attributesToSend = [];
        attributesToSend = this.subAttrIds;

        let bodyRequest = {
          ...orderForm,
          ...(orderForm?.product_coupon_id && {
            product_coupon_id: orderForm.product_coupon_id
          }),
          quantity: orderForm.quantity === '' ? 1 : orderForm.quantity,
          product_id: this.productData.id,
          ...(orderForm.phone && { phone: '+2' + orderForm.phone }),
          ...(this.isBranchExist && this.branchId !== 'main' && { branch_id: this.branchId }),//main is default value for branch id 
          attribute_ids: attributesToSend,
          // add name, and email data if Guest
          ...(this.isNotLoggedIn && {
            name: orderForm.name,
            email: orderForm.email,
          })
        }

        this.isLoading = true;
        this.makeRequest({
          ...(!this.isNotLoggedIn && {
            owner: MAINROLES.user
          }),
          url: APIREQUESTS.user.createOrder.url,
          method: APIREQUESTS.user.createOrder.method,
          formData: JSON.stringify(bodyRequest)
        })
          .then((res) => {
            //check response
            if (!res.status) {//not ok
              reject();
              this.notify({ type: "error", msg: res?.message || this.$t('general.failed') })
            } else {//ok
              const newAccessTokenForGuest = res?.data?.access_token;
              this.changeOrderModalState(false);
              this.notify({ type: "success", msg: this.$t('general.order_success') });

              if (this.isNotLoggedIn) {
                const userAsGuest = {
                  active: 0,
                  authorized_order: 0,
                  cart_items_count: 0,
                  chat_notification_enabled: 0,
                  email: orderForm.email,
                  first_name: orderForm.name,
                  username: orderForm.name,
                  phone: '+2' + orderForm.phone,
                  id: generateRandomId(),
                  token: newAccessTokenForGuest,
                  image: "",
                  language: "ar",
                  last_name: "",
                  role: "guest",
                  store_exists: 0
                };

                this.useLocalStorage({ type: 'set', key: 'user', value: userAsGuest });
                this.$nextTick(() => {
                  this.useLocalStorage({ type: 'set', key: 'favoriteProducts', value: [] });
                })
                // hides and disables the chat page for not initially verifying email
                this.updateDisableChattingState(true);

                this.notify({ type: "info", msg: this.$t('general.guest_account_was_created') });
                this.$nextTick(() => {
                  this.$router.push(ROUTESNAMES.user.orders);
                })
              } else {
                this.$router.push(ROUTESNAMES.user.orders);
              }
              resolve();
            }
          })
          .catch((err) => {
            reject();
            this.notify({ type: "error", msg: err?.data?.message });
          })
          .finally(() => {
            this.isLoading = false
          })

      })

    },
    handleResellerChat() {
      const id = this.productData.id;
      const UID = useCookie?.("UID")?.value ? useCookie?.("UID")?.value : false;
      const storeId = this.productData.store.id;
      this.isCreatingChat = true;
      const modifiedAttrs = this.subAttrIds;
      this.makeRequest({
        owner: MAINROLES.user,  
        method: APIREQUESTS.user.createChat.method,
        url: `${APIREQUESTS.user.createChat.url}/${UID}/${storeId}/${id}`,
      })
        .then(res => {
          this.isCreatingChat = false;
          // failed
          if (res?.message !== 'Response Successfully') {
            this.notify({
              type: "error",
              msg: res.message
            });
          } else {
            // succeeded
            if (res?.data) {
              this.changeOrderModalState(false);
              this.updateForwardedStore(res.data);
              this.$router.push(`${this.ROUTESNAMES.user.chats}?id=${res?.data || ''}`).then(() => {
                this.$router.go();
              });
            }
          }
        })
        .catch(err => {
          this.notify({
            type: "error",
            msg: err?.data?.message || this.$t('general.message_sending_failed')
          });
          this.isCreatingChat = false;

          if (err.status == 402) {
            //store phone  and email token in local storage
            const tempTokens = {
              phone: err?.data?.data?.token?.phone_token,
              email: err?.data?.data?.token?.email_token
            };
            this.useLocalStorage({ type: 'set', key: 'tempTokens', value: tempTokens });

            //go to otp-email
            this.$router.push('/otp?by=email&page=login')

          } else if (err.status == 403) {
            //store email token in local storage
            const tempTokens = {
              email: err?.data?.data?.token?.email_token
            };
            this.useLocalStorage({ type: 'set', key: 'tempTokens', value: tempTokens });

            //go to otp-email
            this.$router.push('/otp?by=email&page=login')
          }
        });
    },
    handleAddToCart() {
      const { id = "" } = this.productData;
      this.isAddingToCart = true;
      const modifiedAttrs = this.subAttrIds;

      this.makeRequest({
        owner: MAINROLES.user,
        method: APIREQUESTS.user.addToCart.method,
        url: APIREQUESTS.user.addToCart.url,
        formData: JSON.stringify({
          product_id: id,
          ...(modifiedAttrs?.length > 0 &&
            { attribute_ids: modifiedAttrs || [] }
          ),
          ...(this.isBranchExist && this.branchId !== 'main' &&
            { branch_id: this.branchId }
          )
        })
      })
        .then(res => {
          this.isAddingToCart = false;
          // failed
          if (!res?.status) {
            this.notify({
              type: "error",
              msg: res.message || this.$t('general.failed')
            });
          } else {
            // succeeded
            if (!isEmpty(this.storedUserData || {}) && (res?.data?.cart_items_count != this.storedUserData?.cart_items_count)) {
              // if item does not exist, increase the Cart counter by one           
              let userObjectCopy = this.storedUserData;
              userObjectCopy.cart_items_count = res?.data?.cart_items_count;
              // set with the newly modified obejct
              useLocalStorage({ type: 'set', key: 'user', value: userObjectCopy });
            }
            fbq('track', 'AddToCart');

            this.notify({ type: "success", msg: this.$t('general.added_to_cart_success') });
          }
        })
        .catch(err => {
          this.notify({
            type: "error",
            msg: err?.data?.message || this.$t('general.message_sending_failed')
          });
          this.isAddingToCart = false;
        });
    },
    onBranchChange(branch) {
      if(branch.id){
        localStorage.setItem('branch', JSON.stringify(branch));
        this.branchData = branch;

      }else{
        localStorage.setItem('branch', 'main');
        this.branchData = {};
      }
      this.$emit('onBranchChange', branch);
    },
    triggerContactPixelEvent() {
      fbq('track', 'Contact');
    },
    toggleGovernorate(id) {
      const index = this.openGovernorates.indexOf(id)
      if (index === -1) {
        this.openGovernorates.push(id)
      } else {
        this.openGovernorates.splice(index, 1)
      }
    },
    displayPricesModal() {
      // Load your governorates data here
      this.governoratesData = this.governoratesList // Your provided data
      this.isShippingPricesModalOpen = true
    },
    handleModalClose() {
      this.isShippingPricesModalOpen = false;
      this.openGovernorates = []; // Reset open governorates when modal closes
    },
    displayAddressModal() {
      this.isAddressSelectionModalOpen = true;
    },
    closeAddressModal() {
      this.showAddressModal = false;
      this.selectedAddress = {};
    },
    handleAddressSubmit(submitData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      this.makeRequest({
        owner: MAINROLES.user,
        url: APIREQUESTS.user.createAddresses.url,
        method: APIREQUESTS.user.createAddresses.method,
        formData: submitData
      })
        .then((res) => {
          if (res.status) {
            this.notify({ type: 'success', msg: this.$t('general.addresses.created_success') });
            this.closeAddressModal();
            // Refresh governorates list or handle success
            this.$emit('addressAdded');
          } else {
            this.notify({ type: 'error', msg: res?.message || this.$t('general.failed') });
          }
        })
        .catch((err) => {
          this.notify({ type: 'error', msg: err?.data?.message });
        })
        .finally(() => {
          this.isSubmitting = false;
          this.showAddressModal = false;
          this.$router.go();
        });
    },
    getAddressesList() {
      this.isLoadingAddresses = true;
      this.makeRequest({
        owner: MAINROLES.user,
        url: APIREQUESTS.user.getAddresses.url,
        method: APIREQUESTS.user.getAddresses.method,
      })
        .then((res) => {
          if (res.status) {
            this.addressesList = res.data.map(address => ({
              id: address.id,
              address_name: address.address_name || this.$t(`addresses.${address.type}`),
              type: this.$t(`addresses.${address.type}`),
              full_address: `${address.street}, ${address.area[`name_${this.$i18n.locale}`]}, ${address.area.governorate[`name_${this.$i18n.locale}`]}`,
              default: address.default === 1,
              ...address
            }));
          }
        })
        .catch((err) => {
          this.notify({
            type: "error", 
            msg: err?.data?.message || this.$t('general.failed'),
          });
        })
        .finally(() => {
          this.isLoadingAddresses = false;
        });
    },
    closeAddressSelectionModal() {
      this.isAddressSelectionModalOpen = false;
    },
    openAddressModal(address) {
      this.selectedAddress = address;
      this.showAddressModal = true;
    },
    makeDefaultAddress(address) {
      this.isLoadingAddresses = true;
      this.makeRequest({
            owner: this.MAINROLES.user,
            url: `${this.APIREQUESTS.user.makeDefaultAddress.url}/${address.id}/default`,
            method: this.APIREQUESTS.user.makeDefaultAddress.method,
        }).then((res) => {
            if(res.status){
              this.$router.go();
            }
        }).catch((err) => {
            this.notify({ type: 'error', msg: err?.data?.message });
        })
        .finally(() => {
          this.isLoadingAddresses = false;
          this.closeAddressSelectionModal();
        });
    },
    formatAreaPrice(price) {
      if(price === undefined) return this.$t('general.areas_prices');
      if (parseInt(price) === -1) return this.$t('general.according_agreement');
      if (parseInt(price) === 0) return this.$t('general.free_shipping');
      return `${this.$t('general.areas_prices_pound', { price: parseInt(price) })}`;
    },

    getGovernoratePrice(governorate) {
      // Check if any areas have different prices
      const hasDifferentPrices = governorate.areas.some((area, index) => {
        if (index === 0) return false;
        return area.price !== governorate.areas[0].price;
      });

      // If any areas have different prices, return undefined
      if (hasDifferentPrices) {
        return this.formatAreaPrice(undefined);
      }

      // All areas have same price, return that price
      return this.formatAreaPrice(governorate.areas[0]?.price);
    },
    handleViewingStoreInteractionModal(type) {
      if (type === 'comments') {
        this.getComments();
      }
    },
    directUserToLoginPage() {
      // Redirect to login page
      this.$router.push('/login');
    },
    getComments() {
      this.isFetchingStoreData = true;
      this.makeRequest({
        owner: MAINROLES.user,
        url: `${APIREQUESTS.user.getStoreRatings.url}?store_id=${this.productData.store.id}`,
        method: APIREQUESTS.user.getStoreRatings.method,
      })
        .then((res) => {
          if (res.status) {
            this.ratingData = res.data;
            this.isStoreCommentsModalOpen = true;
          } else {
            this.notify({ type: 'error', msg: res?.message || this.$t('general.failed') });
          }
        })
        .catch((err) => {
          this.notify({ type: 'error', msg: err?.data?.message || this.$t('general.failed') });
        })
        .finally(() => {
          this.isFetchingStoreData = false;
        });
    },
    startCountdownTimer() {
      // Only run on client side
      if (!process.client) return;
      
      // Clear any existing timer first
      this.stopCountdownTimer();
      
      // Initial update
      this.updateCountdown();
      
      // Set up interval to update every second
      this.timer = setInterval(() => {
        this.updateCountdown();
      }, 1000); // Update every second
    },
    stopCountdownTimer() {
      if (this.timer && process.client) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    openWarningModal() {
      if (this.storeData?.latest_warning) {
        this.currentWarning = this.storeData.latest_warning;
        this.warningModalState = true;
      }
    },
    closeWarningModal() {
      this.warningModalState = false;
      this.currentWarning = null;
    },
  },
  computed: {
    ...mapState(useGlobalStore, {
      favoriteProductsIDs: (store) => store?.getFavoriteProducts || [],
      storedUserData: (store) => store?.localStorageCopy?.user || {}
    }),
    isAvailableProduct() {
      return this.productData?.available === 1 ? true : false;
    },
    isArchivedUnavailable() {
      return this.productData?.available === 0 && this.productData?.archive_type != null;
    },
    shouldShowStoreSection() {
      return this.storeData && this.productData?.archive_type !== 'store';
    },
    randomHashtag() {
      const hashtags = this.storeData?.hashtags ?? [];
      if (!hashtags.length) {
        return null;
      }
      
      const hashtag = hashtags[this.currentHashtagIndex];
      
      return hashtag;
    },
    displayCountdownCounter() {
      if (!this.productData?.offer_end_timestamp) {
        return { time: "0,0,0", strings: `${this.$t('general.weeks')},${this.$t('general.days')},${this.$t('general.hours')}` };
      }
      return this.displayCountdown;
    },
    productViewsDisplay() {
      const viewsCount = Number(this.productData?.views) || 0;
      return this.arabizeNumbers(Number(viewsCount).toLocaleString());
    },
    productListedSince() {
      return this.productData?.since || this.$t('general.not_available');
    },
    randomGovernorates() {
      if (!this.governoratesOptions?.length) return null;
      
      // Create copy of array to avoid modifying original
      const govs = [...this.governoratesOptions];
      const randomGovs = [];
      const numToSelect = Math.min(3, govs.length);

      // Select 3 random governorates
      for (let i = 0; i < numToSelect; i++) {
        const randomIndex = Math.floor(Math.random() * govs.length);
        randomGovs.push(govs[randomIndex]);
        govs.splice(randomIndex, 1);
      }

      // Format the display string
      const formattedGovs = randomGovs.map(gov => gov[`name_${this.$i18n.locale}`]);
      const displayString = formattedGovs.join('، ');
      
      // Add more flag if there are remaining governorates
      const more = this.governoratesOptions.length > 3;

      // Get remaining governorates by filtering out selected ones
      const remainingGovs = this.governoratesOptions.filter(gov => 
        !randomGovs.find(selected => selected.id === gov.id)
      );

      return { 
        displayString, 
        more, 
        selectedGovs: randomGovs,
        remainingGovernorates: remainingGovs 
      };
    },
    formatMessage() {
      const productName = this.productData?.name_ar || '';
      const sku = this.productData?.sku || '';
      const url = window.location.href || '';
      const msg = `${productName}\nكود المنتج: ${sku}\n${url}`;
      
      navigator.clipboard.writeText(msg);
      this.notify({ type: 'success', msg: this.$t('general.copied_successfully') });
    },
    copySKU(message){
      return generateWhatsappLink({ phone_number: this.whatsappNumber, message: message, link: window?.location?.href || "" });
    },
    getAddressFormatted(){
      try {
        const defaultAddress = this.addressesList.find(address => address.default === 1);
        
        if (!defaultAddress) {
          return null;
        }

        const landmark = defaultAddress.landmark || '';
        const area = defaultAddress.area?.[`name_${this.$i18n.locale}`] || '';
        const governorate = defaultAddress.area?.governorate?.[`name_${this.$i18n.locale}`] || '';

        const addressParts = [landmark, area, governorate].filter(part => part);
        return `(${addressParts.join(' , ')})`;

      } catch (error) {
        console.error('Error formatting address:', error);
        return null;
      }
    },
    governorateDeliveries() {
      const governorates = this.governoratesList || [];
      return governorates;
    },
    finalizedNameKey() {
      return this.nameKey || `name_${this.usedCookieLanguage}`;
    },
    finalizedDescriptionKey() {
      return this.descriptionKey || `description_${this.usedCookieLanguage}`;
    },
    groupedByParentsAttributes() {
      return this.productData?.attributes;
    },
    formattedWhatsappLink() {
      return generateWhatsappLink({ phone_number: this.whatsappNumber, message: this.$t('general.product_whatsapp_message'), link: window?.location?.href || "" });
    },
    isBranchExist() {
      return this.productData.branches.length ? true : false
    },
    subAttrIds() {
      //if main attr have one sub-attr send this sub-attr  by default  --->because it is not selectable
      let subAttrIds = this.groupedByParentsAttributes
        .filter((mainAtrr) => mainAtrr.children.length == 1)
        .map((item) => item.children[0]?.id)

      //then collect any sub attrs that user selected
      Object.values(this.selectedAttributes).forEach((selectedSubAttr) => {
        subAttrIds.push(selectedSubAttr.id)
      })
      return subAttrIds
    },
    wholesaleDetailsArray() {
      return this.productData?.wholesale_details || [];
    },
    offerDetailsArray() {
      return this.productData?.offer_details || [];
    },
    storeData() {
      return this.productData?.store || {}
    },
    storeLink() {
      return buildStoreLink(this.storeData?.username);
    },
    shouldShowWarningIcon() {
      const warning = this.storeData?.latest_warning;
      const myStore = this.storeData?.my_store;
      
      if (!warning || !warning.type) return false;
      
      // For 'first' warning, only show if my_store is true
      if (warning.type === 'first') {
        return myStore === true || myStore === 1;
      }
      
      // For 'second' and 'third' warnings, show for everyone
      return warning.type === 'second' || warning.type === 'third';
    },
    isAuthorizedOrder(){
      // if true require login
      // if false allow guest
      localStorage.setItem('authorized_order', this.storeData?.authorized_order);
      return Boolean(this.storeData?.authorized_order)
    },
    haveAddresses() {
      if (!this.governoratesList || !this.governoratesList.length) {
        return false;
      }
      
      return this.governoratesList.some(governorate => 
        governorate.areas && governorate.areas.some(area => area.is_user_address)
      );
    },
    currentShippingPrice() {
      if (!this.governoratesList || !this.governoratesList.length) {
        console.log('currentShippingPrice: governoratesList is empty or undefined');
        return null;
      }
      
      // Debug: log the structure
      console.log('currentShippingPrice: governoratesList structure:', JSON.stringify(this.governoratesList, null, 2));
      
      // Find the area where is_user_address is truthy (could be true, 1, "1", etc.)
      for (const governorate of this.governoratesList) {
        if (governorate.areas && governorate.areas.length > 0) {
          // Check all areas for debugging
          const areasWithFlag = governorate.areas.filter(area => area.is_user_address);
          console.log('currentShippingPrice: areas with is_user_address flag:', areasWithFlag);
          
          const userArea = governorate.areas.find(area => area.is_user_address);
          if (userArea) {
            console.log('currentShippingPrice: found userArea:', userArea);
            if (userArea.price !== undefined && userArea.price !== null) {
              // Convert price to number if it's a string
              const price = typeof userArea.price === 'string' ? parseInt(userArea.price, 10) : userArea.price;
              console.log('currentShippingPrice: returning price:', price);
              return price;
            } else {
              console.log('currentShippingPrice: userArea found but price is undefined or null');
            }
          }
        }
      }
      
      console.log('currentShippingPrice: no matching area found, returning null');
      return null;
    },
    shippingPricesByGovernorate() {
      // Returns array to use for v-for, similar to the prompt
      if (!this.productData?.governorates || this.productData.governorates.length === 0) {
        return [];
      }
      // Copy governorates/areas with prices as numbers, to avoid type bugs
      return this.productData.governorates.map(governorate => ({
        ...governorate,
        areas: (governorate.areas || []).map(area => ({
          ...area,
          price: typeof area.price === 'string' ? parseInt(area.price, 10) : area.price
        }))
      }));
    },
    shippingPriceDisplay() {
      // Hide if no governorates available
      if (!this.productData?.governorates || this.productData.governorates.length === 0) {
        return '';
      }
      console.log('haveAddresses:',this.haveAddresses);
      console.log('currentShippingPrice:',this.currentShippingPrice);
      // If user has addresses, show actual shipping price
      if (this.haveAddresses && this.currentShippingPrice !== null) {
        const price = parseInt(this.currentShippingPrice);
        console.log('price shipping price:',price);
        if (price === 0) {
          // Free shipping
          return ``;
        } else if (price === -1) {
          // By agreement
          return ``;
        } else {
          // Show formatted price: "+ [price] ج.م للتوصيل"
          return `+ ${this.arabizeNumbers(price.toLocaleString())} ${this.$t('general.egy_pounds')} ${this.$t('general.for_shipping')}`;
        }
      }

      // User doesn't have addresses but governorates exist - show generic text
      return `+ ${this.$t('general.shipping_price')}`;
    }
  },

  mounted() {
    if(this.$props.portalPage){
      localStorage.setItem('portalPage', this.$props.portalPage);
    }
    this.getAllGovernorates();
    if(!this.isNotLoggedIn){
      this.getAddressesList();
    }
    localStorage.setItem('branch', 'main')
    localStorage.setItem('wholesale_id', null);
    localStorage.setItem('coupon_id', null);
    localStorage.setItem('governorate_id', null);
    localStorage.setItem('governorate_price', null);
    localStorage.setItem('orderID', null);
    localStorage.setItem('fromCart', false);
    this.startCountdownTimer();
    useGlobalStore().clearOrderDetails();
    useGlobalStore().clearOrderDetailsOffer();
    useGlobalStore().clearOrderDetailsWholesale();
    useGlobalStore().setProductData(this.productData);
    this.maxQuantity = 0;
    this.chosenOffer = {};
    if(this.$route.query.back){
      this.isOrderFormModalOpen =true;
    }
    
    // Start hashtag rotation after a short delay to ensure productData is loaded
    this.$nextTick(() => {
      this.startHashtagRotation();
    });
  },
  watch: {
    // Watch for productData changes to restart hashtag rotation
    'productData.store.hashtags': {
      handler(newHashtags) {
        if (newHashtags && newHashtags.length > 0) {
          this.currentHashtagIndex = 0; // Reset to first hashtag
          this.startHashtagRotation();
        } else {
          this.stopHashtagRotation();
        }
      },
      immediate: true
    }
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.stopHashtagRotation();
    this.stopCountdownTimer();
  }
};
</script>
<style lang="scss" scoped>
strong.governorates {
  &::after {
    content: ",";
    color: #7a7a7a;
  }

  &:last-of-type {
    &::after {
      content: ""
    }
  }
}

html.rtl {
  .governorate--list {
    strong.governorates {
      &::after {
        content: "،";
      }

      &:last-of-type {
        &::after {
          content: ""
        }
      }
    }

  }
}

.branch-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  justify-items: center;
  grid-gap: .9em;

}

input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  width: 1.53rem;
  height: 1.53rem;
  border: 1.8px solid #C1C1C1;
  border-radius: 50%;
  margin-right: 10px;
  background-color: transparent;
  position: relative;
  cursor: pointer;

  &:checked {
    border-color: var(--primary-lighter-clr);
  }
}

input[type="radio"]:checked::before {
  content: "";
  display: block;
  width: 0.813rem;
  height: 0.813rem;
  background-color: var(--primary-lighter-clr);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: appear 0.2s;
}

@keyframes appear {
  0% {
    transform: translate(-50%, -50%) scale(0);
    background-color: #fff;
  }

  45% {
    transform: translate(-50%, -50%) scale(1.6);
    background-color: #64aedf;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.7);
    background-color: #ad97b3;
  }

  55% {
    transform: translate(-50%, -50%) scale(1.6);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
    background-color: #ca8489;
  }
}

.shipping-prices-container {
  max-height: 70vh;
  overflow-y: auto;
  padding: 1.25rem;
  
  // Enhanced scrollbar styling
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f8f8f8;
    border-radius: 8px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #dadada;
    border-radius: 8px;
    border: 1px solid #f8f8f8;
    
    &:hover {
      background: #c1c1c1;
    }
  }

  // Add smooth animation for expanding/collapsing
  [v-if] {
    animation: slideDown 0.2s ease-out;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--primary-lighter-clr);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.group:hover .group-hover\:block {
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hashtag-transition {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.hashtag-enter-active,
.hashtag-leave-active {
  transition: all 0.3s ease;
}

.hashtag-enter-from,
.hashtag-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.hashtag-enter-to,
.hashtag-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>